export const ArrowDown: React.FC<React.SVGProps<SVGSVGElement>> = ({
  color = "#23252A",
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="13"
    fill="none"
    viewBox="0 0 10 13"
  >
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="m.883 8.541 3.75 3.75 3.75-3.75M4.633.625v11.25"
    ></path>
  </svg>
);
